import { ID } from './actionTypes';
import DataID from '../config';

export const tooltipsSelector = ({
    [DataID]: {
        [ID]: tooltips,
    },
}) => tooltips;
